import { BackendResponse } from "../BackendResponse";

export interface GetCandidateFavoritesResponse extends BackendResponse {
  items: string[];
}

export interface GetCandidateFavoritesParameters {
  idConcern: number;
  idCandidate: number;
}

export type getCandidateFavorites = (
  args: GetCandidateFavoritesParameters
) => Promise<GetCandidateFavoritesResponse>;

export const getCandidateFavorites: getCandidateFavorites = async (args) => {
  throw new Error("not implemented");
};
